module.exports = __webpack_public_path__ + "media/images/icons/chevron-top-9839a8cbc745edeac1eb92224e8b5d36.svg";